<section class="space-y-4">
  <div class="flex flex-wrap items-center justify-between gap-3">
    <div>
      <h1 class="text-xl font-semibold text-gray-800">System Consistency</h1>
      <div class="text-sm text-gray-500">
        @if (lastRun) {
          {{ lastRun.checkedAt | plainDateTime }} · {{ lastRun.findingsCount }} Findings
        } @else if (findings.length) {
          {{ findings[0].checked_at | plainDateTime }} · {{ findings.length }} Findings
        } @else {
          Keine aktuellen Inkonsistenzen
        }
      </div>
    </div>
    <p-button label="Prüfen" icon="pi pi-refresh" [loading]="running" (click)="runChecks()"></p-button>
  </div>

  <p-table [value]="findings" [loading]="loading" [tableStyle]="{ 'min-width': '72rem' }" styleClass="p-datatable-sm">
    <ng-template pTemplate="header">
      <tr>
        <th>Check</th>
        <th>Severity</th>
        <th>Entity</th>
        <th>Soll</th>
        <th>Ist</th>
        <th>Differenz</th>
        <th>Details</th>
        <th>Checked</th>
      </tr>
    </ng-template>
    <ng-template pTemplate="body" let-finding>
      <tr>
        <td class="whitespace-nowrap">{{ finding.check_key }}</td>
        <td class="whitespace-nowrap">{{ finding.severity }}</td>
        <td class="whitespace-nowrap">
          @if (entityLink(finding); as link) {
            <a [routerLink]="link" target="_blank" rel="noopener noreferrer" class="text-primary hover:underline">
              {{ finding.entity_type }} {{ finding.entity_label || finding.entity_id }}
            </a>
          } @else {
            {{ finding.entity_type }} {{ finding.entity_label || finding.entity_id }}
          }
        </td>
        <td class="max-w-80 whitespace-normal break-words">{{ finding.expected_value }}</td>
        <td class="max-w-80 whitespace-normal break-words">{{ finding.actual_value }}</td>
        <td class="whitespace-nowrap">{{ finding.difference_value }}</td>
        <td class="max-w-80 whitespace-normal break-words">{{ finding.details }}</td>
        <td class="whitespace-nowrap">{{ finding.checked_at | plainDateTime }}</td>
      </tr>
    </ng-template>
    <ng-template pTemplate="emptymessage">
      <tr>
        <td colspan="8" class="py-6 text-center text-gray-500">Keine aktuellen Inkonsistenzen</td>
      </tr>
    </ng-template>
  </p-table>
</section>
